define("shared/components/shared/social/twitter-deprecation/modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div {{did-insert this.checkTwitterAccounts}}>
    {{#if this.showTwitterDeprecationModal}}
      <Shared::Modal @close={{this.closeModal}} as |modal|>
        <modal.card class="tOB--image__deprecationTW">
          <modal.card-body>
            <div class="u--row u--row--noCollapse">
              <div class="u--col__7 u--col__push--5">
                <modal.card-header class="u--p__b__0">
                  <h1 class="o--modalHeader__title u--text--lg u--p__b__sm">
                    {{t "twitter-deprecation.modal.title"}}
                  </h1>
                </modal.card-header>
  
                <modal.card-body>
                  {{html-safe (t "twitter-deprecation.modal.body")}}
                  <div class="u--relative u--m__t__lg">
                    <Shared::Ui::Button @additional="block" @onClick={{this.openLink}} @size="large" @variant="primary">
                      {{t "shared_words.learn_more"}}
                    </Shared::Ui::Button>
                  </div>
                </modal.card-body>
              </div>
            </div>
          </modal.card-body>
        </modal.card>
      </Shared::Modal>
    {{/if}}
  </div>
  */
  {
    "id": "KMeXuIBv",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"checkTwitterAccounts\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showTwitterDeprecationModal\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@close\"],[[30,0,[\"closeModal\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card\"]],[[24,0,\"tOB--image__deprecationTW\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__7 u--col__push--5\"],[12],[1,\"\\n              \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__0\"]],null,[[\"default\"],[[[[1,\"\\n                \"],[10,\"h1\"],[14,0,\"o--modalHeader__title u--text--lg u--p__b__sm\"],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"twitter-deprecation.modal.title\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n\\n              \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,4],[[28,[37,3],[\"twitter-deprecation.modal.body\"],null]],null]],[1,\"\\n                \"],[10,0],[14,0,\"u--relative u--m__t__lg\"],[12],[1,\"\\n                  \"],[8,[39,5],null,[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"openLink\"]],\"large\",\"primary\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,3],[\"shared_words.learn_more\"],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[1]]]]],[1,\"\\n\"]],[]],null],[13]],[\"modal\"],false,[\"did-insert\",\"if\",\"shared/modal\",\"t\",\"html-safe\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/social/twitter-deprecation/modal.hbs",
    "isStrictMode": false
  });
  const TWITTER_DEPRECATION_MODAL_CACHE_KEY = 'twitter_deprecation_modal';
  let TwitterDeprecationModalComponent = _exports.default = (_class = class TwitterDeprecationModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "showTwitterDeprecationModal", _descriptor3, this);
    }
    get twitterProfiles() {
      return this.auth.currentGroup.twitterProfiles;
    }
    get groupHasTwitterAccounts() {
      return Boolean(this.twitterProfiles?.length);
    }
    get cacheKey() {
      return `${TWITTER_DEPRECATION_MODAL_CACHE_KEY}_${this.auth.currentGroup.id}`;
    }
    get hasSeenModal() {
      return Boolean(this.cache.retrieve(this.cacheKey));
    }
    checkTwitterAccounts() {
      if (this.groupHasTwitterAccounts && !this.hasSeenModal) {
        this.showTwitterDeprecationModal = true;
        this.cache.add(this.cacheKey, true, {
          expiry: this.cache.maxExpiryDate(),
          persist: true
        });
      }
    }
    closeModal() {
      this.showTwitterDeprecationModal = false;
      if (typeof this.args.closeModal === 'function') {
        this.args.closeModal();
      }
    }
    openLink() {
      window.open('https://help.later.com/hc/en-us/articles/33709975610135', '_blank');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showTwitterDeprecationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "checkTwitterAccounts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "checkTwitterAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openLink"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TwitterDeprecationModalComponent);
});